import https from 'https';
import getConfig from '../../config';
import { getLogger } from '../SearchLogger';

export default class LoggerService {
	hostContext: HostContext;

	constructor(hostContext: HostContext) {
		this.hostContext = hostContext;
	}

	// Sends the payload to CCHome Support Server
	async sendLog(logLevel: LogLevel, payload: Record<string, any>): Promise<void> {
		// levelToLogToServer defines the level which we want to send to the server
		const levelToLogToServer = ['info', 'warn', 'error'];
		const postData = {
			level: logLevel,
			message: payload,
		};

		if (levelToLogToServer.indexOf(logLevel) !== -1) {
			try {
				if (this.hostContext.imsInfo.accessToken) {
					await this.sendLogRequest(logLevel, payload);

					if (this.hostContext.featureFlags.includes('ccsearch_enable_ui_logger_console_splunk')) {
						getLogger().log('LoggerService', 'CCHome Support Server Logger Payload:', postData);
					}
				}
			} catch (error) {
				if (this.hostContext.featureFlags.includes('ccsearch_enable_ui_logger_console_splunk')) {
					getLogger().error('LoggerService', 'CCHome Support Server error sending Payload', {
						postData,
						error,
					});
				}
			}
		}
	}

	/** Send Logs via network call to CCHome Support Server
	 * @param {LogLevel} level
	 * @param {Object} message
	 */
	sendLogRequest(logLevel: LogLevel, message: Record<string, any>): Promise<any> {
		return new Promise((resolve: any, reject: any) => {
			const postData = {
				level: logLevel,
				message,
			};
			const request = https.request(
				{
					hostname: getConfig(this.hostContext.environment, 'APP_SERVER'),
					path: '/v2/logs',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-api-key': this.hostContext.hostInfo.apiKey,
						Authorization: `Bearer ${this.hostContext.imsInfo.accessToken}`,
					},
				},
				(res: any) => {
					if (res && res.statusCode && res.statusCode >= 300) {
						reject(res.statusCode);
					} else {
						let data = '';
						res.setEncoding('utf8');
						res.on('data', (chunk) => (data += chunk));
						res.on('end', () => {
							// Success!
							try {
								resolve(data);
							} catch (e) {
								reject(e);
							}
						});
					}
				},
			);
			request.on('error', (err) => {
				reject(err);
			});
			request.write(JSON.stringify(postData));
			request.end();
		});
	}
}
